import { Flex, IconPlus, Text, useMenuState } from '@vtex/admin-ui'
import { FormattedMessage, useIntl } from 'react-intl'
import { FieldGroupBox, MenuButtonWithIcon } from 'ui'
import { RegularBenefitVariant } from '../../../../../../typings'
import { BenefitMenu } from '../../../../../BenefitMenu'
import { BENEFIT_OPTIONS } from '../constants'
import { messages } from './messages'
import { styles } from './styles'

type EmptyProps = {
  name: string
  onAdd: (name: RegularBenefitVariant) => void
}

export function Empty(props: EmptyProps) {
  const { name, onAdd } = props

  const { $t } = useIntl()

  const menuState = useMenuState({ placement: 'bottom-start' })

  return (
    <FieldGroupBox name={name}>
      <Flex direction="column" className={styles.content}>
        <Text variant="action2">
          <FormattedMessage {...messages.empty.description} />
        </Text>
        <MenuButtonWithIcon
          state={menuState}
          variant="secondary"
          label={$t(messages.empty.add)}
          icon={<IconPlus />}
        />
        <BenefitMenu
          state={menuState}
          onAdd={onAdd}
          options={BENEFIT_OPTIONS}
        />
      </Flex>
    </FieldGroupBox>
  )
}
